export default __webpack_public_path__ + "static/media/compass.555e0ba7.svg";